<div class="d-flex flex-row align-items-center text-nowrap">
  <ng-container *ngIf="depositDetail?.status === 'wait_pay' else depositDisabled" [formGroup]="setForm">
    <nz-input-number
      formControlName="deposit"
      [nzPlaceHolder]="'reservation.detail.deposit.item.fee_placeholder' | translate"
      (nzBlur)="requestSetDeposit()"></nz-input-number>
  </ng-container>
  <ng-template #depositDisabled>
    <ng-container *ngIf="depositDetail?.status === 'paid'">
      <input
        type="text"
        nz-input
        readonly="readonly"
        [disabled]="true"
        [placeholder]="depositDetail.receivable > 0
                          ? (depositDetail.receivable + ('reservation.detail.deposit.status.paid' | translate))
                          : (depositDetail.deducted + ('reservation.detail.deposit.status.deducted' | translate))"
      >
    </ng-container>

    <ng-container *ngIf="depositDetail?.status === 'refunded'">
      <input
        type="text"
        nz-input
        [disabled]="true"
        readonly="readonly"
        [placeholder]=" depositDetail.receivable > 0
                          ? (depositDetail.refunded + ('reservation.detail.deposit.status.refunded' | translate))
                          : (depositDetail.deducted + ('reservation.detail.deposit.status.deducted' | translate))">
    </ng-container>
  </ng-template>
  <div
    class="label-btn ml-10"
    nz-popover
    [nzPopoverTitle]="depositTitle"
    [nzPopoverContent]="depositContent">
    {{ "reservation.detail.deposit.item.detailed" | translate }}
    <!-- 明细 -->
  </div>
  <ng-template #depositTitle>
    <div class="d-flex flex-row align-items-center justify-content-between" style="width:260px">
      <span>
        {{ "reservation.detail.deposit.item.deposit_detailed" | translate }}
        <!-- 押金明细 -->
      </span>
      <div>
        <a href="javascript:void(0)" class="link-text" (click)="displayDeductDepositModal(deductedTpl)"
           *ngIf="depositDetail?.status !== 'wait_pay'">
          {{ "reservation.detail.deposit.op.deduct" | translate }}
          <!-- 扣押金 -->
        </a>
        <a href="javascript:void(0)" class="link-text ml-10" (click)="displayRefundDepositModal()"
           *ngIf="depositDetail?.status !== 'wait_pay'">
          <!-- 退押金 -->
          {{ "reservation.detail.deposit.op.refund" | translate }}
        </a>
      </div>
    </div>
  </ng-template>
  <ng-template #depositContent>
    <ng-container *ngIf="depositDetail?.status === 'wait_pay'">
      <span class="item">
        {{ "reservation.detail.deposit.op.text.receivable" | translate: {
                        number: depositDetail.receivable
                      } }}
        <!-- 应收 {{ depositDetail.receivable }} -->
      </span>
    </ng-container>
    <ng-container *ngIf="depositDetail?.status === 'paid'">
      <span class="item">
        {{ "reservation.detail.deposit.op.text.paid" | translate: {
                        number: depositDetail.paid
                      } }}
        <!-- 已收 {{ depositDetail.paid }} -->
      </span>
      <span class="item ml-10">
        {{ "reservation.detail.deposit.op.text.deduct" | translate: {
        number: depositDetail.deducted
      } }}
        <!-- 扣除 {{ depositDetail.deducted }} -->
      </span>
      <span class="item ml-10">
        {{ "reservation.detail.deposit.op.text.pending" | translate: {
        number: depositDetail.pending_refund
      } }}
        <!-- 待退 {{ depositDetail.pending_refund }} -->
      </span>
    </ng-container>
    <ng-container *ngIf="depositDetail?.status === 'refunded'">
      <span class="item">
        {{ "reservation.detail.deposit.op.text.paid" | translate: {
                        number: depositDetail.paid
                      } }}
        <!-- 已收 {{ depositDetail.paid }} -->
      </span>
      <span class="item ml-10">
        {{ "reservation.detail.deposit.op.text.deduct" | translate: {
        number: depositDetail.deducted
      } }}
        <!-- 扣除 {{ depositDetail.deducted }} -->
      </span>
      <span class="item ml-10">
        {{ "reservation.detail.deposit.op.text.refund" | translate: {
        number: depositDetail.refunded
      } }}
        <!-- 已退 {{ depositDetail.refunded }} -->
      </span>
    </ng-container>
  </ng-template>
  <ng-template #deductedTpl>
    <div class="refund-container">
      <div class="tip">
        {{ "reservation.detail.deposit.modal.deduct.title" | translate }}
        <!-- 请输入准备扣除的金额 -->
      </div>
      <div [formGroup]="deductForm" class="control" style="padding: 20px 0 10px">
        <input
          type="number"
          nz-input
          formControlName="wait_deducted_deposit">
      </div>
      <div class="info">
        <span class="s1" style="margin-right: 20px">
          {{ "reservation.detail.deposit.op.text.paid" | translate: {
            number: depositDetail?.paid
          } }}
          <!-- 已收 {{ depositDetail?.paid }} -->
        </span>
        <span class="s2">
          {{ "reservation.detail.deposit.op.text.pending" | translate: {
            number: depositDetail?.paid - waitDeductedDeposit | number:'1.0-3'
          } }}
          <!-- 待退
        {{
        depositDetail?.paid -
      depositDetail?.waitDeductedDeposit | number:
        '1.0-3' }} -->
        </span>
      </div>
    </div>
  </ng-template>
</div>
